import React from 'react';
import HelpContent from './HelpContent';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const ElectrificacionIndustriaMineriaHelp = () => (
  <HelpContent>
   <h1>Electrificación de usos usos motrices en la industria y minería</h1>
   <p>
    Esta medida evalua el impacto de la electrificación de los usos motrices de la industria y minería. 
    La electrificación de usos motrices en la industria y minería (excluye cobre) busca implementar soluciones que posibiliten la transición de los vehículos de transporte y 
    maquinaria empleados en la industria y minería, que actualmente utilizan combustibles fósiles, a una operación eléctrica basada en baterías
    </p>
    <p>
    <strong>Trayectoria 1:</strong> 
    </p>
    <p>
    Industria: la participación de electricidad en usos motrices es de 6,4% en 2030, un 14,6% en 2040 y alcanza un 21,5% en 2050.
    </p>
    <p>
    Minería: la participación de electricidad en usos motrices es de 16,9% en 2030, un 28,6% en 2040 y alcanza un 43% en 2050.
    </p>
    <p>
    <strong>Trayectoria 2:</strong> 
    </p>
    <p>
    Industria: la participación de electricidad en usos motrices es de 6,4% en 2030, un 17,8% en 2040 y alcanza un 31,5% en 2050.
    </p>
    <p>
    Minería: la participación de electricidad en usos motrices es de 16,9% en 2030, un 29,8% en 2040 y alcanza un 52,8% en 2050.
    </p>
  </HelpContent>
);

export default ElectrificacionIndustriaMineriaHelp;
